<template>
  <section>
    <img class="leaf" src="../../../../../src/assets/images/leaves/l16.png" align="left"/>
    <div class="container">
      <div class="alex-content">
        <div class="heading mb-3">ALEX - Adaptive Learning<br>Experience</div>
        <div class="sub-heading mb-base">Agile in Microlearning – Why it’s the next big thing?</div>
        <div>
<!--          <vs-button type="border" color="white" class="mr-3">TRY DEMO</vs-button>-->
<!--          <vs-button type="filled" color="white" text-color="#dc0032">START NOW</vs-button>-->
        </div>
      </div>
    </div>
  </section>
</template>

<script>
    export default {
        name: "Header"
    }
</script>

<style scoped>
  section {
    position: relative;
    min-height: 100vh;
    background: url("../../../../../src/assets/images/demo/alex-header.svg") center;
    background-size: cover;
  }

  .alex-content {
    position: absolute;
    margin: 15rem 0;
  }

  .alex-content .heading {
    font-style: normal;
    font-weight: 600;
    font-size: 60px;
    line-height: 115%;
    /* or 94px */
    letter-spacing: -0.04em;
    color: #FFFFFF;
  }

  .alex-content .sub-heading {
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    line-height: 38px;
    /* identical to box height, or 190% */
    letter-spacing: -0.01em;
    color: #FFFFFF;
  }

  button {
    border-radius: 100px;
  }

  .leaf {
    position: absolute;
    top: 0;
    left: 0;
    width: 500px;
  }

  @media (max-width: 1200px) {
    section {
      padding: 5rem 0;
    }

    .leaf {
      width: -webkit-fill-available;
      width: -moz-available;
    }

    .alex-content {
      margin: 3rem 0;
    }

    .alex-content .heading {
      font-size: 50px;
    }

    .alex-content .sub-heading {
      font-size: 18px;
    }
  }
</style>
